export const CHEF_EXPERIENCE_TIMES = { breakfast: "7:30 AM", lunch: "12:00 PM", dinner: "7:00 PM", fullday: "" };

export const SERVICES = [
  {
    id: "chef",
    gatherings: [
      { id: "two", guests: 2 },
      { id: "together", guests: 4 },
      { id: "gathering", guests: 6 },
    ],
    experiences: ["breakfast", "lunch", "dinner", "fullday"],
  },
  {
    id: "massage",
    durations: ["pause", "escape"],
  },
];
